/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteTriggeredAction} from '../api'

export const useMutationDeleteTriggeredAction = createReactQueryMutationHook('deleteTriggeredAction', deleteTriggeredAction)
